$(function () {

    const header = $("#header");
    const pageSelector = $(".page");
    const headerInitialHeight = $("#header").not('.fixed').innerHeight();

    $(window).on("scroll", function (event) {
        let scrollPos = $(window).scrollTop();
        let headerH = $("#header").not('.fixed').innerHeight();
        let pageIndent = headerInitialHeight;

        if (headerH != headerInitialHeight) {
            pageIndent = headerH;
        }

        if (scrollPos > headerInitialHeight) {
            pageSelector.css('paddingTop', pageIndent);
            header.addClass("fixed");
        } else {
            pageSelector.css('paddingTop', 0);
            header.removeClass("fixed");
        }
    });

    const searchToggle = $("#searchToggle");
    const search = $("#headerSearch");

    searchToggle.on("click", () => {
        if (!search.hasClass('opened')) {
            search.addClass("opened");
        } else {
            search.removeClass("opened");
        }
    });
});